<section class="wraper-sub">
  <div class="Writer-progress-m orderIn-progress-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Order In-Progress</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="statusWriter"
                placeholder="Active Writer"
                [(ngModel)]="searchParams.status"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                bindLabel= "name"
                bindValue = "value"
                (change)= "rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>

              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="writers"
                placeholder="All Writer"
                [(ngModel)]="searchParams.writer_id"
                [ngModelOptions]="{standalone: true}"
                [searchable]="true"
                [clearable]="true"
                bindLabel= "name"
                bindValue = "id"
                (change)="rerender()"
                >
                <ng-template ng-label-tmp let-item="item" *ngIf="leads.writer_id == 0">
                    Select Writer
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="orderProgress-tabs-m">
          <a href="javascript:;" class="first" routerLink="/support/writers-progress" routerLinkActive = "active" [routerLinkActiveOptions]="{exact: true}">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.4719 1.30503L13.7984 0.275273V0.264128C13.7984 0.118265 13.6799 0 13.5336 0C13.3874 0 13.2688 0.118265 13.2688 0.264128V5.74515H12.8933C12.5916 5.74515 12.3461 5.99002 12.3461 6.29099V8.68354H8.77798C8.47625 8.68354 8.23077 8.9284 8.23077 9.22938V11.6219H4.66257C4.36085 11.6219 4.11537 11.8668 4.11537 12.1678V14.5604H0.547207C0.245478 14.5604 0 14.8052 0 15.1062V17.4542C0 17.7551 0.245478 18 0.547207 18H14.6434C14.7896 18 14.9082 17.8817 14.9082 17.7359C14.9082 17.59 14.7896 17.4717 14.6434 17.4717H12.8757V8.94764V6.29095C12.8757 6.28125 12.8836 6.27334 12.8933 6.27334H16.4439C16.4536 6.27334 16.4615 6.28121 16.4615 6.29095V17.4541C16.4615 17.4638 16.4536 17.4717 16.4439 17.4717H15.9077C15.7615 17.4717 15.6429 17.59 15.6429 17.7359C15.6429 17.8817 15.7615 18 15.9077 18H16.4439C16.7456 18 16.9911 17.7551 16.9911 17.4542V6.29095C16.9911 5.98998 16.7456 5.74512 16.4439 5.74512H13.7984V3.72522L14.4884 3.53179C14.6291 3.49234 14.7112 3.34648 14.6716 3.20607C14.6321 3.06565 14.4859 2.98371 14.3451 3.02326L13.7984 3.1765V0.823955L17.3287 1.81353C17.4603 1.85045 17.4705 1.96576 17.4705 2.00025C17.4705 2.0347 17.4602 2.15005 17.3287 2.18696L15.4571 2.7116C15.3163 2.75104 15.2343 2.8969 15.2738 3.03732C15.3133 3.17773 15.4594 3.25972 15.6003 3.22013L17.4719 2.69549C17.7878 2.60697 18 2.32755 18 2.00028C18 1.67294 17.7878 1.39356 17.4719 1.30503ZM0.529585 17.4541V15.1062C0.529585 15.0965 0.53748 15.0885 0.547242 15.0885H4.1154V17.4717H0.547207C0.53748 17.4717 0.529585 17.4638 0.529585 17.4541ZM8.49556 14.0559C8.34933 14.0559 8.23077 14.1742 8.23077 14.32V17.4717H4.64495V14.8244V12.1678C4.64495 12.1581 4.65285 12.1502 4.66261 12.1502H8.2308V13.1085C8.2308 13.2544 8.34937 13.3727 8.4956 13.3727C8.64183 13.3727 8.76039 13.2544 8.76039 13.1085V9.22934C8.76039 9.21964 8.76828 9.21173 8.77805 9.21173H12.3462V17.4717H8.76032V14.32C8.76032 14.1741 8.64179 14.0559 8.49556 14.0559Z" fill="#075595"/>
            </svg>
            <span>View Writers Progress</span>
          </a>
          <a href="javascript:;" routerLink="/support/writers-subjects" routerLinkActive = "active" [routerLinkActiveOptions]="{exact: true}">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.99 16.5749C17.9899 16.5747 17.9899 16.5745 17.9898 16.5743L13.5065 0.216258C13.4637 0.0609238 13.3005 -0.0314155 13.1415 0.00982698L9.10167 1.06797C9.04626 1.08403 8.99698 1.11585 8.9601 1.15936V0.532475C8.9601 0.371228 8.82637 0.240493 8.66143 0.240493H0.29867C0.133729 0.240493 0 0.371228 0 0.532475V17.4674C0 17.6287 0.133729 17.7594 0.29867 17.7594H8.66143C8.82637 17.7594 8.9601 17.6287 8.9601 17.4674V1.67938L13.3738 17.7836C13.4089 17.9113 13.5272 18 13.6624 18C13.6882 17.9998 13.7138 17.9965 13.7388 17.9901L17.7777 16.9319C17.9372 16.8907 18.0322 16.7308 17.99 16.5749ZM4.18138 17.1754H0.59734V0.824457H4.18138V17.1754ZM8.36276 17.1754H4.77872V0.824457H8.36276V17.1754ZM13.8735 17.3506L9.5449 1.55646L13.0068 0.649267L17.3354 16.4434L13.8735 17.3506Z" fill="#075595"/>
              <path d="M3.28551 1.99237H1.49349C1.32855 1.99237 1.19482 2.12311 1.19482 2.28435C1.19482 2.4456 1.32855 2.57633 1.49349 2.57633H3.28551C3.45045 2.57633 3.58418 2.4456 3.58418 2.28435C3.58418 2.12311 3.45045 1.99237 3.28551 1.99237Z" fill="#075595"/>
              <path d="M3.28551 3.16034H1.49349C1.32855 3.16034 1.19482 3.29107 1.19482 3.45232C1.19482 3.61357 1.32855 3.7443 1.49349 3.7443H3.28551C3.45045 3.7443 3.58418 3.61357 3.58418 3.45232C3.58418 3.29107 3.45045 3.16034 3.28551 3.16034Z" fill="#075595"/>
              <path d="M7.46715 1.99237H5.67513C5.51019 1.99237 5.37646 2.12311 5.37646 2.28435C5.37646 2.4456 5.51019 2.57633 5.67513 2.57633H7.46715C7.6321 2.57633 7.76582 2.4456 7.76582 2.28435C7.76582 2.12311 7.6321 1.99237 7.46715 1.99237Z" fill="#075595"/>
              <path d="M7.46715 3.16034H5.67513C5.51019 3.16034 5.37646 3.29107 5.37646 3.45232C5.37646 3.61357 5.51019 3.7443 5.67513 3.7443H7.46715C7.6321 3.7443 7.76582 3.61357 7.76582 3.45232C7.76582 3.29107 7.6321 3.16034 7.46715 3.16034Z" fill="#075595"/>
              <path d="M12.8244 2.21655C12.786 2.05971 12.6248 1.96303 12.4644 2.00059C12.4592 2.00183 12.454 2.00318 12.4488 2.00468L10.7165 2.45783C10.557 2.49878 10.4616 2.65842 10.5035 2.81438C10.5454 2.97033 10.7087 3.06359 10.8682 3.02263C10.8691 3.02242 10.87 3.02216 10.871 3.02194L12.6035 2.56849C12.764 2.53094 12.8628 2.37338 12.8244 2.21655Z" fill="#075595"/>
              <path d="M13.1269 3.33902C13.0842 3.18325 12.9204 3.09084 12.761 3.13259H12.7598L11.029 3.58604C10.8695 3.62699 10.7741 3.78663 10.816 3.94258C10.8579 4.09854 11.0212 4.19179 11.1807 4.15084C11.1816 4.15062 11.1825 4.15036 11.1835 4.15015L12.9157 3.6967C13.0751 3.65494 13.1696 3.49479 13.1269 3.33902Z" fill="#075595"/>
              <path d="M16.0609 14.0554C16.0178 13.9008 15.8555 13.8091 15.697 13.8498L13.9647 14.3032C13.8054 14.3449 13.7108 14.505 13.7534 14.6608C13.7884 14.7885 13.9068 14.8773 14.0421 14.8773H14.0432C14.0693 14.8772 14.0954 14.8739 14.1206 14.8673L15.8514 14.4139C16.0105 14.3715 16.1043 14.211 16.0609 14.0554Z" fill="#075595"/>
              <path d="M16.3733 15.1836C16.3301 15.0291 16.1678 14.9374 16.0093 14.978L14.2767 15.4315C14.1174 15.4731 14.0228 15.6332 14.0654 15.789C14.1004 15.9167 14.2188 16.0055 14.3541 16.0055C14.3802 16.0055 14.4062 16.0021 14.4314 15.9953L16.1637 15.5421C16.3228 15.4997 16.4166 15.3392 16.3733 15.1836Z" fill="#075595"/>
              <path d="M7.46715 14.2556H5.67513C5.51019 14.2556 5.37646 14.3864 5.37646 14.5476C5.37646 14.7088 5.51019 14.8396 5.67513 14.8396H7.46715C7.6321 14.8396 7.76582 14.7088 7.76582 14.5476C7.76582 14.3864 7.6321 14.2556 7.46715 14.2556Z" fill="#075595"/>
              <path d="M7.46715 15.4235H5.67513C5.51019 15.4235 5.37646 15.5543 5.37646 15.7155C5.37646 15.8768 5.51019 16.0075 5.67513 16.0075H7.46715C7.6321 16.0075 7.76582 15.8768 7.76582 15.7155C7.76582 15.5543 7.6321 15.4235 7.46715 15.4235Z" fill="#075595"/>
              <path d="M3.28551 14.2556H1.49349C1.32855 14.2556 1.19482 14.3864 1.19482 14.5476C1.19482 14.7088 1.32855 14.8396 1.49349 14.8396H3.28551C3.45045 14.8396 3.58418 14.7088 3.58418 14.5476C3.58418 14.3864 3.45045 14.2556 3.28551 14.2556Z" fill="#075595"/>
              <path d="M3.28551 15.4235H1.49349C1.32855 15.4235 1.19482 15.5543 1.19482 15.7155C1.19482 15.8768 1.32855 16.0075 1.49349 16.0075H3.28551C3.45045 16.0075 3.58418 15.8768 3.58418 15.7155C3.58418 15.5543 3.45045 15.4235 3.28551 15.4235Z" fill="#075595"/>
            </svg>
            <span>View Writers Subjects</span>
          </a>
        </div>
      </div>
    </div>

    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>S#</th>
              <th>Writer</th>
              <th>Ratings</th>
              <th>Last Submission Date</th>
              <th>Orders  In Process</th>
              <th>Orders Completed</th>
              <th>Pages</th>
              <th>V - Revisions</th>
              <th>IV - Revisions</th>
              <th>Late Submissios</th>
              <th>Disputed Orders</th>
              <th>Warnnigs</th>
              <th>Joining</th>
              <th>Status</th>
            </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ paginatePage + (indx + 1) }}</td>
                <td (click) = "writerDetail(indx)">
                  <div class="pos-rel">
                    <p class="id">{{ lead.name }}</p>
                    <div class="writerDetail-m" *ngIf="WriterDetailFlag">
                      <!-- Modal -->
                      <div class="modal fade" [id]="'writerDetail'+indx " tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Writer’s Details</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <ul class="year-selection-p" >
                                <li>
                                  <label>Name:</label>
                                  <span>{{lead.name}}</span>
                                </li>
                                <li>
                                  <label>Email: </label>
                                  <span>{{lead.email}}</span>
                                </li>
                                <li>
                                  <label>Password:</label>
                                  <span>{{lead.password}}</span>
                                </li>
                                <li>
                                  <label>Phone #:</label>
                                  <span>{{lead.phone}}</span>
                                </li>
                                <li  class="bankDetails">
                                  <label class="bankSub" *ngFor="let bank of lead.bank_detail">
                                    <label>{{ bank.split(":")[0]}}</label>
                                    <span>{{ bank.split(":")[1]}}</span>
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </td>
                <td>
                  <div class="stars genralFeedback" (click) = "clientModal(indx)">
                    <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.positive_feedback) >= 1 , 'active-half': parseFloat(lead.positive_feedback) > 0 && parseFloat(lead.positive_feedback) < 1 }"></i>
                    <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.positive_feedback) >= 2 , 'active-half': parseFloat(lead.positive_feedback) > 1 && parseFloat(lead.positive_feedback) < 2 }"></i>
                    <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.positive_feedback) >= 3 , 'active-half': parseFloat(lead.positive_feedback) > 2 && parseFloat(lead.positive_feedback) < 3 }"></i>
                    <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.positive_feedback) >= 4 , 'active-half': parseFloat(lead.positive_feedback) > 3 && parseFloat(lead.positive_feedback) < 4}"></i>
                    <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.positive_feedback) >= 5 , 'active-half': parseFloat(lead.positive_feedback) > 4 && parseFloat(lead.positive_feedback) < 5}"></i>
                  </div>
                  <div class="pos-rel">
                    <div class="clientFeedback-m" *ngIf="FeedbackModalFlag">
                      <!-- Modal -->
                      <div class="modal fade" [id]="'clientFeedback'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Client Feedback</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="clientFeedback-Sub">
                                <p class="title-sub">Total Feedbacks : {{lead.all_feedback_count}}</p>
                                <div class="feedbackRound">
                                  <div class="rounded-Sub">
                                    <div class="roundeFeeback">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 34 34">
                                        <circle cx="14" cy="14" r="12.9155" class="progress-bar__background" />
                                        <circle cx="14" cy="14" r="12.9155" class="progress-bar__progress js-progress-bar" />
                                      </svg>

                                      <span>{{FeedbackPercentPositive}}%</span>
                                    </div>
                                    <div class="feedback-Bar">
                                      <span class="feedbackbar-Sub" [ngStyle]="{'width': FeedbackPercentPositive + '%'}"></span>
                                    </div>
                                    <div class="feedback-text">
                                      <p>Postivie:{{lead.positive_feedback_count}}</p>
                                    </div>
                                  </div>
                                  <div class="rounded-Sub negFeed">
                                    <div class="roundeFeeback">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 34 34">
                                        <circle cx="14" cy="14" r="12.9155" class="progress-bar__background" />
                                        <circle cx="14" cy="14" r="12.9155" class="progress-bar__progress js-progress-barNeg" />
                                      </svg>
                                      <span>{{FeedbackPercentNegative}}%</span>
                                    </div>
                                    <div class="feedback-Bar">
                                      <span class="feedbackbar-Sub" [ngStyle]="{'width': FeedbackPercentNegative + '%'}"></span>
                                    </div>
                                    <div class="feedback-text">
                                      <p>Negative:{{lead.negative_feedback_count}}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <p *ngIf="lead.last_submission_date == '0000-00-00 00:00:00' || lead.last_submission_date == '--' ">-</p>
                  <ng-container *ngIf="lead.last_submission_date != '0000-00-00 00:00:00' &&  lead.last_submission_date != '--' ">
                      <p class="time-done">{{ lead.last_submission_date | date }}</p>
                      <p class="time-done">{{ lead.last_submission_date | date:'shortTime' }}</p>
                  </ng-container>
                </td>
                <td>
                  <p>{{lead.orders_in_process}}</p>
                </td>
                <td>
                  <p>{{lead.orders_completed}}</p>
                </td>
                <td>
                  {{lead.total_pages}}
                </td>
                <td>
                  {{lead.v_revisions}}
                </td>
                <td>
                  {{lead.iv_revisions}}
                </td>
                <td>
                  <p>{{lead.late_submissions}}</p>
                </td>
                <td>
                  <p>{{lead.disputed_orders}}</p>
                </td>
                <td>
                  <p>{{lead.warnings}}</p>
                </td>
                <td>
                  <p *ngIf="lead.joining == '0000-00-00 00:00:00'">-</p>
                  <p *ngIf="lead.joining" class="time-done">{{ lead.joining | date }}</p>
                  <p class="time-done">{{ lead.joining | date:'shortTime' }}</p>
                </td>
                <td>
                  <div class="fields-m disposition-open select-m" [ngClass]="{'invalid': lead.status == 0}">
                    <ng-select
                    [items]="statusWriter"
                    placeholder="Status"
                    [(ngModel)]="lead.status"
                    [ngModelOptions]="{standalone: true}"
                    [searchable]="false"
                    [clearable]="false"
                    bindLabel= "name"
                    bindValue = "value"
                    (change)= "updateWriterStatus(lead, indx)"
                    >
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      {{ item.name }}
                    </ng-template>

                  </ng-select>
                </div>
                <!-- <p>{{ lead.status_text }}</p> -->
              </td>
          </tr>
            </tbody>
        </ng-container>

        </table>
      </div>
    </div>


    <div class="comment-modal-m">
      <div class="modal fade" id="comment_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel1" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">Agent Comments</h5>
            <h5 class="modal-title qa-comment" id="exampleModalLabel1" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">Q/A Comments</h5>
          </div>
          <div class="modal-content">
            <div class="modal-body">
              <div class="comments-sub" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">
                <ng-container *ngFor="let comment of agentComments">
                  <div class="comment-box">
                    <label *ngIf="agents">{{ agentSearch(comment.user_id, agents) }}</label>
                    <p>{{ comment.notes }}</p>
                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                  </div>
                </ng-container>

              </div>
              <div class="comments-sub qa-box" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">
                <ng-container *ngFor="let comment of qaComments">
                  <div class="comment-box">
                    <label *ngIf="agents">{{ agentSearch(comment.user_id, qa) }}</label>
                    <p>{{ comment.notes }}</p>
                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                  </div>
                </ng-container>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- notes modal start -->

    <div class="notesModal">
      <div class="modal fade" id="notesModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-header">
            <h5 class="modal-title">Add Notes</h5>
          </div>
          <div class="modal-content">
            <div class="modal-body">
                <form action="">
                    <div class="formItem shadowed w-100">
                        <textarea class="" placeholder="Enter Bank Details"></textarea>
                    </div>
                    <div class="formBtns text-right">
                        <button class="pBtn">Add</button>
                    </div>
                </form>
                <h5 class="modal-title">All Notes</h5>
                <ul class="allNotes">
                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>
                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua.</li>
                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua.</li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- notes modal end-->

  </div>
</section>
